import {getBackButton, getCancelButton} from "../../../constants/RouteDefinitions";
import {IButton, TRouteIdOrDefinition} from "../../../index";
import backHtml from './back.html?raw';

export const template = backHtml

interface IBackButtonParams {
    idOrDef?: TRouteIdOrDefinition
    config?: Partial<IButton>
}

export class viewModel {
    private readonly btn: Partial<IButton>
    constructor(params: IBackButtonParams = {}) {
        this.btn = getBackButton(params.idOrDef, params.config)
    }
}